<template>
  <div>
    <titulo-modulo titulo="Notificações" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <v-alert type="info" text v-else-if="notificacoes.length == 0" class="mt-3">
      Nenhuma notificação encontrada
    </v-alert>
    <!--<template v-else-if="$mq != 'sm'">
      <v-row class="mt-1">
        <v-col xl="4" lg="4" md="4" sm="12" cols="12">
          <v-card flat :min-height="height" class="h-100">
            <v-card-title class="font-weight-bold subtitle-1 pb-0"
              >Notificações recebidas</v-card-title
            >
            <v-card-text>
              <v-col
                cols="12"
                class="pb-1"
                v-if="getQtdMsgNaoVisualizadas() > 0"
              >
                <v-chip small v-if="getQtdMsgNaoVisualizadas() == 1">
                  {{ getQtdMsgNaoVisualizadas() }} mensagem não lida</v-chip
                >
                <v-chip small v-else-if="getQtdMsgNaoVisualizadas() > 1">
                  {{ getQtdMsgNaoVisualizadas() }} mensagens não lidas</v-chip
                >
              </v-col>
              <v-list v-if="getListaNotificacoes().length > 0" two-line>
                <v-list-item-group>
                  <template v-for="(notif, i) in getListaNotificacoes()">
                    <v-list-item
                      :key="notif.idmensagem"
                      three-line
                      :disabled="notif.idmensagem == idMensagemSelec"
                      @click="idMensagemSelec = notif.idmensagem"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ notif.titulo }}</v-list-item-title
                        >
                        <v-list-item-subtitle class="caption"
                          >Recebida em {{ notif.data }} às
                          {{ notif.hora }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon v-if="notif.visualizada" color="info"
                          >mdi-check-all</v-icon
                        >
                        <v-icon color="yellow" size="16" v-else
                          >mdi-circle</v-icon
                        >
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider :key="i"></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
              <v-alert class="text-center subtitle-2 grey--text" v-else
                >Nenhuma notificação encontrada</v-alert
              >
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xl="8" lg="8" md="8" sm="12" cols="12">
          <v-card flat :min-height="height">
            <template v-if="idMensagemSelec > 0">
              <v-card-title
                class="font-weight-bold green lighten-4 primary--text"
                >{{ getMensagem().titulo }}</v-card-title
              >
              <v-card-text
                class="pt-5 w-100"
                v-html="conteudoNotificacao"
              ></v-card-text>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </template>-->
    <v-expansion-panels focusable class="mt-4" v-model="panel">
      <v-expansion-panel v-for="(notif, i) in getListaNotificacoes()" :key="i">
        <v-expansion-panel-header @click="idMensagemSelec = notif.idmensagem">
          <v-row dense>
            <v-col cols="12">
              <span
                ><v-icon v-if="notif.visualizada" color="info"
                  >mdi-check-all</v-icon
                >
                <v-icon color="yellow" size="16" v-else>mdi-circle</v-icon
                ><span class="subtitle-1 ml-3">{{ notif.titulo }}</span></span
              >
            </v-col>
            <v-col cols="12">
              <small>Recebida em {{ notif.data }} às {{ notif.hora }}</small>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="grey lighten-4">
          <v-card
            class="mt-4 d-flex justify-center"
            rounded="lg"
            flat
            :loading="loadingConteudo"
          >
            <v-card-text
              :class="imgClass()"
              v-html="conteudoNotificacao"
            ></v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";

export default {
  components: { TituloModulo },
  watch: {
    idMensagemSelec: async function () {
      this.loadingConteudo = true;
      await this.getConteudoMsg();
      this.loadingConteudo = false;
      this.setVisualizada();
    },
    panel: async function (value) {
      if (value != undefined) {
        this.idMensagemSelec = this.notificacoes[value].idmensagem;
      }
    },
  },
  data: () => ({
    carregando: false,
    conteudoNotificacao: "",
    idMensagemSelec: 0,
    timer: "",
    panel: 999999,
    loadingConteudo: true,
  }),
  computed: mapState("notificacao", ["notificacoes", "height"]),
  methods: {
    ...mapActions("notificacao", ["getNotificacoes"]),
    ...mapGetters("notificacao", ["getQtdMsgNaoVisualizadas"]),
    async getConteudoMsg() {
      this.conteudoNotificacao = "";
      await axios
        .post("/colaborador/mensagem?funcao=CONTEUDO", {
          id: this.idMensagemSelec,
        })
        .then((res) => {
          this.conteudoNotificacao = res.data;
        })
        .catch((e) => this.$toasted.error(e));
    },
    getMensagem() {
      return this.notificacoes.find(
        (notif) => notif.idmensagem == this.idMensagemSelec
      );
    },
    setVisualizada() {
      axios
        .post("colaborador/mensagem?funcao=MARCAR-COMO-LIDA", {
          id: this.getMensagem().idmsgusuario,
        })
        .then((res) => {
          if (res.data.success) {
            this.getMensagem().visualizada = true;
          }
        });
    },
    getListaNotificacoes() {
      var qtdExibir = 10;
      var listaNotif = [];
      for (let index = 0; index < qtdExibir; index++) {
        if (index >= this.notificacoes.length) break;
        listaNotif.push(this.notificacoes[index]);
      }

      return listaNotif;
    },
    imgClass() {      
      if (this.$mq != "sm" && this.conteudoNotificacao.includes("<img")) {
        return "img-50";
      }
    },
  },
  async mounted() {
    this.carregando = true;
    await this.getNotificacoes();
    this.carregando = false;
  },
};
</script>

<style>
.img-50 {
  width: 50% !important;
}
</style>
